import crudActions from './crudActions';
import loading from './loading';

export default {
    crudActions,
    loading,
};
